module.exports = __webpack_public_path__ + "img/6.c5cd89ea.jpg";